import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, retry, delay, scan, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SharedService {
  constructor(private _http: HttpClient) { }

  getAllDist(): Observable<any[]> {
    return this._http.get<any[]>(environment.apiBase + '/signup/district/all');
  }

  getAllStates(): Observable<any[]> {
    return this._http.get<any[]>(environment.apiBase + '/signup/state/all');
  }

  getDistrict(stateId): Observable<any[]> {
    return this._http.get<any[]>(environment.apiBase + '/signup/district/all/' + stateId);
  }

  getTaluka(distId): Observable<any> {
    return this._http.get<any>(environment.apiBase + `/signup/taluka/all?district=${distId}`)
  }

  createUser(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/api/auth/office/signup', payload)
  }

  sentOtp(mobNo): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/api/auth/office/send-otp/'+mobNo, "")
  }

  userShortInfo(userId): Observable<any> {
    return this._http.get<any>(environment.apiBase + '/api/user/getshortinfo/'+userId)
  }

  updateCompany(payload, companyKey): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/company/update/' + companyKey, payload)
  }

  approvalCompany(payload): Observable<any> {
    return this._http.patch<any>(environment.apiBase + '/company/approvalflow', payload)
  }

  addApproverCompany(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/approvalflow/create', payload)
  }

  updateApproverCompany(payload): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/approvalflow/update', payload)
  }

  getApprovalCompany(moduleName) {
    return this._http.get<any>(environment.apiBase + `/approvalflow/get/${moduleName}`)
  }

  getCompanyDetailsById(id: any) {
    return this._http.get<any>(`${environment.apiBase}/company/get?id=` + id);
  }

  getBranches() {
    return this._http.get<any[]>(`${environment.apiBase}/branch/all`);
  }

  getBranchesByUser() {
    return this._http.get<any[]>(`${environment.apiBase}/branch/user`);
  }

  createBranch(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/branch/create', payload)
  }

  updateBranch(payload, branchKey): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/branch/update/' + branchKey, payload)
  }

  getWarehouses() {
    return this._http.get<any[]>(`${environment.apiBase}/warehouse/all`);
  }

  createWarehouse(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/warehouse/create', payload)
  }

  updateWarehouse(payload, warehouseKey): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/warehouse/update/' + warehouseKey, payload)
  }
  fetchWarehouseByProductKey(productKey) {
    return this._http.get<any[]>(`${environment.apiBase}/stock/balancestock/` + productKey);
  }

  deleteClient(id): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/client/updatestatus/' + id, {})
  }

  deleteClientById(id): Observable<any> {
    return this._http.delete<any>(environment.apiBase + '/client/delete/' + id);
  }

  getClients() {
    return this._http.get<any[]>(`${environment.apiBase}/client/all`);
  }

  getAllActiveClients() {
    return this._http.get<any[]>(`${environment.apiBase}/client/all?isForTrans=true`);
  }

  createClient(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/client/create', payload)
  }

  updateClient(payload, clientKey): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/client/update/' + clientKey, payload)
  }

  getSuppliers() {
    return this._http.get<any[]>(`${environment.apiBase}/supplier/all`);
  }

  createSupplier(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/supplier/create', payload)
  }

  updateSupplier(payload, supplierKey): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/supplier/update/' + supplierKey, payload)
  }

  deleteSupplier(id): Observable<any> {
    return this._http.delete<any>(environment.apiBase + '/supplier/delete/' + id);
  }

  // getallRoles
  getAllActiveRoles(): Observable<any[]> {
    return this._http.get<any[]>(environment.apiBase + '/roles/all?isTransaction=true');
  }
  getAllActiveDesignation(): Observable<any[]> {
    return this._http.get<any[]>(environment.apiBase + '/designation/all?isTransaction=true');
  }

  createRole(role:any): Observable<any> {
    return this._http.post<any>(environment.apiBase + `/roles/add/role?role=${role}`,role);
  }

  createDesignation(designation:any): Observable<any> {
    return this._http.post<any>(environment.apiBase + `/designation/add/designation?designation=${designation}`,designation);
  }

  // change pswword 
  changeNewPassword(payload, id): Observable<any> {
    return this._http.put<any[]>(environment.apiBase + '/api/user/updatepass/' + id, payload);
  }

  //Permission
  createPermission(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + '/permission/create', payload)
  }

  getPermissionyDetailsById(roleId: any) {
    return this._http.get<any>(`${environment.apiBase}/roles/get/access/of/role/` + roleId);
  }

  getUserPermissionyDetailsById(userId: any) {
    return this._http.get<any>(`${environment.apiBase}/role-access/get/access/of/user/` + userId);
  }

  updatePermission(payload): Observable<any> {
    return this._http.put<any>(environment.apiBase + '/permission/update', payload)
  }


  ///////////////////////Customer////////////////////////////////
  getAllCustomer(): Observable<any[]> {
    return this._http.get<any[]>(environment.apiBase + '/api/user/getAllUsers?customer=true');
  }

   getAllFeedback(): Observable<any[]> {
    return this._http.get<any[]>(environment.apiBase + '/contact-us');
  }

  ////////////////////////////Dashborad/////////////////////////////////
  getDashbordSummary(): Observable<any[]> {
    return this._http.get<any[]>(environment.apiBase + '/dashboard');
  }

  getRecentTopTenOrder():Observable<any[]>{
        return this._http.get<any[]>(environment.apiBase + '/order/get/all/orders?acceptBy=0&top10=true');

  }

  //   tokenVerify(payload): Observable<any> {
  //   return this._http.post<any>(environment.apiBase + '/permission/create', payload)
  // }

}